import { Page } from "@/models/page-models/Page";

export const MachineMachineId: Page = {
  "path": "machine/:machineId",
  "name": "View Machine",
  "props": {
    "data": {
      "title": "View Machine",
      "printable": "FALSE",
      "url": "machine/:machineId",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.name",
                  "label": "Name",
                  "disabled": "FALSE"
                },
                {
                  "type": "radioGroup",
                  "variable": "formData.isContinuous",
                  "label": "Output Movement",
                  "onVarUpdate": [
                    {
                      "executionOrder": 1,
                      "name": "copySpeedUnit"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "[{\"label\":\"stroke/min\",\"value\":false},{\"label\":\"m/min\",\"value\":true}]"
                },
                {
                  "type": "input",
                  "variable": "formData.mechanicalSpeed",
                  "label": "Speed",
                  "unit": "{{fetchedData.selectedSpeedUnit}}",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "Possible Processes"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "checkboxGroup",
                  "variable": "formData.possibleProcesses",
                  "label": "Possible Processes",
                  "disabled": "FALSE",
                  "items": "[\"Slitting\",\"Sheeting\",\"Automatic Die Cutting\",\"Die Cutting\",\"Guillotine Cutting\",\"Paper Printing\",\"PSL Printing\",\"Lamination\",\"Tray Forming\",\"Doilies\",\"Embossing\",\"Packing\",\"Sachet Forming\",\"Bag Forming\",\"Cup Forming\",\"Coating\",\"Narrow Slitting\",\"Corrugating\",\"Trading\"]"
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Save",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "setConvertedSpeed",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getConvertedSpeed",
                        "arg2Key": "destinationKey",
                        "arg2Value": "formData",
                        "arg3Key": "destinationKeyType",
                        "arg3Value": "Object",
                        "arg4Key": "append",
                        "arg4Value": "TRUE"
                      },
                      "name": "setConvertedSpeed"
                    },
                    {
                      "executionOrder": 2,
                      "name": "saveMachine"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ]
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "name": "getMachineData"
      }
    ],
    "functions": [
      {
        "name": "getMachineData",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/machine/{{__params.machineId}}",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.machineData",
        "arg3Key": "fnsAfterSubmit",
        "arg3Value": "[{\"name\":\"copyMachineData\",\"executionOrder\":1}]"
      },
      {
        "name": "copyMachineData",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "fetchedData.machineData.data",
        "arg2Key": "destinationKey",
        "arg2Value": "formData"
      },
      {
        "name": "getConvertedSpeed",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "mechanicalSpeed": "fn(NUMBER,{{formData.mechanicalSpeed}})"
        },
        "useFormula": true
      },
      {
        "name": "saveMachine",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/machine/{{formData._id}}",
        "arg2Key": "postData",
        "arg2Value": "formData",
        "arg3Key": "fnsAfterSubmit",
        "arg3Value": "[{\"name\":\"redirectToMachines\",\"executionOrder\":1}]"
      },
      {
        "name": "redirectToMachines",
        "type": "fnRedirect",
        "arg1Key": "redirectUrl",
        "arg1Value": "/machines"
      },
      {
        "name": "copySpeedUnit",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__selectedObject.label",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedSpeedUnit"
      }
    ]
  },
  "forRole": "PRODUCTION_MANAGER",
  "visible": false
}